import { useEffect } from 'react';
import { Mixpanel } from '../../utils/mixpanel';
import { AICA_RELATED_PARTY, AICA_MANAGEMENT_PROFILE_VIEWED } from '../../utils/constants/mixpanelEvents/investorEvents';

interface UseDashboardTabAnalyticsParams {
    selectedTab?: string;
    investorOrgId?: string;
    companyOrgId?: string;
}

export function useDashboardTabAnalytics({ selectedTab, investorOrgId, companyOrgId }: UseDashboardTabAnalyticsParams) {
    useEffect(() => {
        if (!selectedTab || !investorOrgId || !companyOrgId) {
            return;
        }

        if (selectedTab === 'relatedParty') {
            Mixpanel.track(AICA_RELATED_PARTY, {
                parentId: investorOrgId,
                websiteUrl: window.location.href,
                companyOrgId,
            });
        }

        if (selectedTab === 'managementProfile') {
            Mixpanel.track(AICA_MANAGEMENT_PROFILE_VIEWED, {
                parentId: investorOrgId,
                websiteUrl: window.location.href,
                companyOrgId,
            });
        }
    }, [selectedTab, investorOrgId, companyOrgId]);
}
